import createItemFetcher from "../helpers/item";
import { combineDucks } from "../helpers/combineDucks";
import { createFileSave } from "./fileSave";
import { createActionDuck } from "../helpers/action";
import { createLockStatusDuck } from "../helpers/lock";
import { createNotificationOnSaveEpic } from "./saveNotification";
import { createNotificationOnLockErrorEpic } from "./lockErNotification";
import { createListenToDataFileChangesEpic } from "./fileUpdate";
import { createUseFetch } from "../helpers/fetchHooks";
import React from "react";
export function createFile(config) {
    const { computeFileUrl } = config;
    function computeItemId(config) {
        const { scenario, workspace, program, mode, panelName } = config;
        return `${scenario}_${workspace}_${program}_${mode}_${panelName}`;
    }
    const fileItemDuck = createItemFetcher(computeFileUrl, "FILE", computeItemId);
    const fileSaveDuck = createFileSave(computeFileUrl, computeItemId);
    const computeFileLockUrl = (config) => ({
        url: `${computeFileUrl(config)}/lock`,
        method: "POST",
    });
    const fileLockDuck = createActionDuck("FILE_LOCK", computeFileLockUrl, computeItemId);
    const computeFileUnlockUrl = (config) => ({
        url: `${computeFileUrl(config)}/unlock`,
        method: "POST",
    });
    const fileUnlockDuck = createActionDuck("FILE_UNLOCK", computeFileUnlockUrl, computeItemId);
    const lockStatusDuck = createLockStatusDuck(fileLockDuck.ActionKeys, fileUnlockDuck.ActionKeys, fileSaveDuck.ActionKeys, computeItemId);
    const combinedDuck = combineDucks({
        save: fileSaveDuck,
        lockStatus: lockStatusDuck,
        lock: fileLockDuck,
        unlock: fileUnlockDuck,
        data: fileItemDuck,
    });
    const saveNotificationEpic = createNotificationOnSaveEpic(fileSaveDuck.ActionKeys);
    combinedDuck.middleware.push(saveNotificationEpic);
    const notificationEpic = createNotificationOnLockErrorEpic(fileLockDuck.ActionKeys);
    combinedDuck.middleware.push(notificationEpic);
    const listenToDataPanelChangesEpic = createListenToDataFileChangesEpic(fileItemDuck.actions.fetchItem);
    combinedDuck.middleware.push(listenToDataPanelChangesEpic);
    return combinedDuck;
}
function computeItemId(config) {
    return `${config === null || config === void 0 ? void 0 : config.fileName}`;
}
export function createViewableFile(config) {
    const { computeViewableFileUrl } = config;
    const viewablefiles = createItemFetcher(computeViewableFileUrl, "VIEWABLE_FILE", computeItemId);
    const viewablefilesWithUseFetch = Object.assign(Object.assign({}, viewablefiles), { useViewableFileFetcher: createUseFetch(viewablefiles, (state) => state.viewablefiles, false) });
    viewablefiles.middleware.push(createListenToDataFileChangesEpic(viewablefiles.actions.fetchItem));
    return viewablefilesWithUseFetch;
}
export const ViewableFilesContext = React.createContext({});
//# sourceMappingURL=index.js.map